export const TaskActionDefinition = {
  ActionDefinitionId: 'Internal.Task',
  FieldId_TaskDescription: 'c1ab59ff-6dcf-4f90-8055-8a1d84145864',
  FieldId_Assignee: '27db498a-3bbc-4de2-afbb-3e180aa3b394'
} as const;
